module.exports = __webpack_public_path__ + "static/media/covered-porch.60cd6b93.svg";